export default ($axios) => ({
    $axios,

    async fetch(query) {
        return await $axios.get(`/partners${query}`)
    },

    async fetchById(id) {
        return await $axios.get(`/partners/${id}`)
    },

    async create(form) {
        return await $axios.post('/partners', form)
    },

    async update(id, form) {
        return await $axios.put(`/partners/${id}`, form)
    },

    async remove(id) {
        return await $axios.delete(`/partners/${id}`)
    },
})
